<template>
  <Table
    :fields="tableFields"
    :items="tableItems"
    :toDetail="toDetail"
  />
</template>

<script>
import Table from '@/components/project/molecules/Table.vue'

import { FIELDS } from '../enums/payment-links-fields.enum'

export default {
  name: 'PaymentLinksTable',

  components: {
    Table
  },

  props: {
    items: Array,
    fields: {
      type: Array,
      default: () => FIELDS
    },
    toDetail: Object
  },

  computed: {
    tableFields () {
      return this.fields.map(item => ({
        ...item,
        label: this.$t(item.label),
        text: this.$t(item?.text)
      }))
    },
    tableItems () {
      return this.items.map(item => ({
        ...item,
        type: this.$t(`items.${item.type}`)
      }))
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "list": {
        "id": "ID",
        "name": "Nome",
        "type": "Tipo",
        "amount": "Valor Total",
        "status": "Status",
        "url": "Url",
        "createdAt": "Criado Em",
        "updatedAt": "Última atualização"
      },
      "items": {
        "Pedido único": "Cobrança única",
        "Assinatura recorrente": "Cobrança recorrente",
        "url": "Acessar URL"
      }
    },
    "en-US": {
      "list": {
        "id": "ID",
        "name": "Name",
        "type": "Type",
        "amount": "Amount",
        "status": "Status",
        "url": "Url",
        "createdAt": "Created at",
        "updatedAt": "Last updated"
      },
      "items": {
        "Pedido único": "Unique charge",
        "Assinatura recorrente": "Recurring charges",
        "url": "Open link"
      }
    }
  }
</i18n>
